import { LoginForm } from "../components/login-form";

export default function LoginPage() {
  return (
    <div className="h-full flex flex-col gap-7 items-center justify-center">
      <div className="space-y-2">
        <h1 className="text-xl font-semibold">
          Welcome Back to Transcript Genie
        </h1>
        <h2 className="text-sm text-neutral-600">
          Enter your credentials to access your account
        </h2>
      </div>
      <LoginForm />
    </div>
  );
}
